/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetAutoSavePointReqQueryDto
 */
export interface GetAutoSavePointReqQueryDto {
    /**
     * 시작 날짜
     * @type {string}
     * @memberof GetAutoSavePointReqQueryDto
     */
    'startDate'?: string;
    /**
     * 끝 날짜
     * @type {string}
     * @memberof GetAutoSavePointReqQueryDto
     */
    'endDate'?: string;
    /**
     * 포인트 카테고리 id 목록
     * @type {string}
     * @memberof GetAutoSavePointReqQueryDto
     */
    'pointType'?: GetAutoSavePointReqQueryDtoPointTypeEnum;
}

export const GetAutoSavePointReqQueryDtoPointTypeEnum = {
    Like: 'like',
    Follow: 'follow',
    Comment: 'comment',
    Pagelike: 'pagelike',
    Subscribe: 'subscribe',
    Post: 'post',
    Install: 'install',
    Rating: 'rating',
    Join: 'join',
    Friend: 'friend',
    Event: 'event',
    Blog: 'blog',
    Scrap: 'scrap',
    Bookmark: 'bookmark',
    Notification: 'notification',
    CampaignReport: 'campaign_report',
    UserReport: 'user_report',
    Admin: 'admin',
    Badge: 'badge',
    SnsAccountDelete: 'sns_account_delete',
    Exchange: 'exchange'
} as const;

export type GetAutoSavePointReqQueryDtoPointTypeEnum = typeof GetAutoSavePointReqQueryDtoPointTypeEnum[keyof typeof GetAutoSavePointReqQueryDtoPointTypeEnum];


